import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityYiDunBillV2StatusVO } from '../Type/PackEntityYiDunBillV2StatusVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询安全通计费2.0状态
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] aid
 * @param {string} [data.cid] cid
 */

export function funcyiDunBillV2statusquery(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityYiDunBillV2StatusVO>
export function funcyiDunBillV2statusquery(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityYiDunBillV2StatusVO extends { msg: unknown } ? PackEntityYiDunBillV2StatusVO['msg'] : undefined>
export function funcyiDunBillV2statusquery(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/yiDunBillV2/status/query', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
